<template>
  <section class="">
    <button class="cart-menu" v-if="totalItems > 0" @click="goToCart">
      Naar bestellen
    </button>
  </section>
</template>

<script>
import { mapStores } from 'pinia'
import { useCheckOutStore } from '@/features/checkOut/CheckOut.store'
import { usePrintStoreStore } from '@/features/printstore/PrintStore.store'

export default {
  components: {},
  methods: {
    goToCart() {
      this.$router.push({ name: 'checkOut' })
    }
  },
  computed: {
    ...mapStores(usePrintStoreStore, useCheckOutStore),
    totalItems() {
      return (
        this.checkOutStore.products.length +
        this.printStoreStore.orderDetails.cart.length
      )
    }
  }
}
</script>

<style lang="scss" scoped>
.cart-menu {
  height: 46px;
  background-color: var(--arch-color);
  color: #4f4f4f;
  border-radius: 32px;
  box-shadow: rgba(0, 0, 0, 0.33) 0 0 32px -4px;
  width: 200px;
  top: 90px;
  position: fixed;
  z-index: 100;
  right: 20px;
  padding: 0 20px;
  font-size: 0.82rem;
  font-weight: 600;
}

.count-holder {
  display: inline-block;
  position: relative;

  img {
    position: relative;
  }

  .count {
    position: absolute;
    left: 0;
    top: 0;
  }
}

.cart {
  vertical-align: middle;
}
</style>
